/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { SitemapControllerGetSitemapQueryResponse } from '../types/SitemapControllerGetSitemap.ts';

function getSitemapGetSitemapUrl() {
  const res = { method: 'GET', url: `/api/sitemap` as const };
  return res;
}

/**
 * {@link /api/sitemap}
 */
export async function sitemapGetSitemap(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<SitemapControllerGetSitemapQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getSitemapGetSitemapUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
